import dynamic from 'next/dynamic';

import LazyHydration from 'components/LazyHydration';

const FeaturedReviews = dynamic(() => import('./FeaturedReviews'), {
  ssr: false,
});

const DynamicallyFeaturedReviews = (props) => (
  <LazyHydration placeholderSize={{ height: 328 }}>
    <FeaturedReviews {...props} />
  </LazyHydration>
);

export default DynamicallyFeaturedReviews;
